import * as React from 'react';
import { st, classes } from './CoreCheckbox.st.css';
import { filterDataProps } from '../../utils/FilterDataProps';
export const noop = () => null;
export class CoreCheckbox extends React.Component {
    constructor() {
        super(...arguments);
        this.focusedByMouse = false;
        this.state = { isFocused: false, focusVisible: false };
        this.handleMouseDown = (event) => {
            // When clicking on the label, the input loses focus style state and then gains it again.
            // To prevent this we disable the default mouse down behavior and set the state to true
            if (!this.props.disabled) {
                event.preventDefault();
                this.focusedByMouse = true;
                this.setState({
                    isFocused: true,
                });
            }
        };
        this.handleInputKeyDown = () => {
            this.setState({ focusVisible: true });
        };
        this.handleInputBlur = (event) => {
            this.state.isFocused &&
                this.setState({ isFocused: false, focusVisible: false });
            this.focusedByMouse = false;
            this.props.onBlur && this.props.onBlur(event);
        };
        this.handleInputFocus = (event) => {
            !this.focusedByMouse &&
                this.props.onFocusByKeyboard &&
                this.props.onFocusByKeyboard(event);
            this.setState({ isFocused: true, focusVisible: !this.focusedByMouse });
        };
        this.handleChange = (event) => {
            this.props.onChange({ checked: !this.props.checked, ...event });
        };
    }
    focus(options) {
        this.checkbox?.focus(options);
    }
    render() {
        const { checked, disabled, error, indeterminate, indeterminateIcon, checkedIcon, uncheckedIcon, } = this.props;
        return (React.createElement("label", { className: st(classes.root, {
                checked,
                disabled,
                readonly: this.props.readOnly,
                error,
                indeterminate,
                focus: this.state.isFocused,
                'focus-visible': this.state.focusVisible,
            }, this.props.className), onMouseDown: this.handleMouseDown, ...filterDataProps(this.props) },
            React.createElement("input", { type: "checkbox", className: classes.nativeCheckbox, onClick: (e) => e.stopPropagation(), onChange: this.handleChange, onKeyDown: this.handleInputKeyDown, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, ref: (ref) => (this.checkbox = ref), 
                // temp fix
                checked: checked, disabled: disabled, readOnly: this.props.readOnly, tabIndex: this.props.tabIndex, id: this.props.id, required: this.props.required, autoFocus: this.props.autoFocus, name: this.props.name, "aria-controls": this.props['aria-controls'], "aria-label": this.props['aria-label'], "aria-invalid": this.props['aria-invalid'], "aria-describedby": this.props['aria-describedby'] }),
            React.createElement("span", { className: classes.box }, this.props.indeterminate
                ? indeterminateIcon
                : this.props.checked
                    ? checkedIcon
                    : uncheckedIcon),
            this.props.children ? (React.createElement("div", { className: classes.childContainer }, this.props.children)) : null));
    }
}
CoreCheckbox.displayName = 'CoreCheckbox';
CoreCheckbox.defaultProps = {
    onChange: noop,
    checked: false,
    indeterminate: false,
    tabIndex: 0,
    onBlur: noop,
};
//# sourceMappingURL=CoreCheckbox.js.map